module.exports = __webpack_public_path__ + "media/images/new_landing/case/case-nescafe-13701b1204b068fbbfbe063cdabeb893.jpg";